import { jsx as _jsx } from "react/jsx-runtime";
import useRewards from '../../../../../hooks/useRewards';
import Earnings from '../../../../../ui/molecules/Earnings';
import RewardsProgress from '../../../../../ui/molecules/RewardsProgress';
import CashRewardsBalance from '../../../../../ui/molecules/CashRewardsBalance';
var ModalRewardsProgressAndEarnings = function () {
    var _a = useRewards(), hasCashRewardsBalance = _a.hasCashRewardsBalance, hasCertificateHistory = _a.hasCertificateHistory;
    if (hasCashRewardsBalance) {
        return _jsx(CashRewardsBalance, {});
    }
    if (hasCertificateHistory) {
        return _jsx(RewardsProgress, { className: "inside-drawer" });
    }
    return _jsx(Earnings, { className: "inside-drawer" });
};
export default ModalRewardsProgressAndEarnings;
